module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_05.396a5881.svg";